module.exports = __webpack_public_path__ + "img/465-275e72.png";